// Utility functions for verse highlighting
// Now stores the color index (number) instead of the hex code for theme compatibility.

export function getHighlightKey(book, chapter, verse) {
  const key = `highlight-${book}-${chapter}-${verse}`;
  console.log("[highlightUtils] getHighlightKey:", {
    book,
    chapter,
    verse,
    key,
  });
  return key;
}

// Returns the color index (number) or null
export function getHighlight(book, chapter, verse) {
  const key = getHighlightKey(book, chapter, verse);
  const value = localStorage.getItem(key);
  console.log("[highlightUtils] getHighlight:", { key, value });
  return value !== null ? parseInt(value, 10) : null;
}

// colorIndex should be a number (or null to clear)
export function setHighlight(book, chapter, verse, colorIndex) {
  const key = getHighlightKey(book, chapter, verse);
  if (typeof colorIndex === "number") {
    localStorage.setItem(key, String(colorIndex));
    console.log("[highlightUtils] setHighlight: set", { key, colorIndex });
  } else {
    localStorage.removeItem(key);
    console.log("[highlightUtils] setHighlight: remove", { key });
  }
}
